module.exports = __webpack_public_path__ + "static/media/octolytics.ef8f0927.png";